import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "./components/ui/card";

export const ContractorSection = ({ t }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.contractor.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-md">
            <h3 className="font-bold mb-2">{t.contractor.company}</h3>
            <p>
              nimbicon GmbH<br />
              Münchener Straße 20<br />
              85774 Unterföhring
            </p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h3 className="font-bold mb-2">{t.contractor.registration}</h3>
            <p>
              Amtsgericht München, HRB 265027<br />
              USt-IdNr: DE342602782<br />
              LEI: 984500D9D83MF3FGCT25
            </p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h3 className="font-bold mb-2">{t.contractor.representative}</h3>
            <p>Alexander Weise (Geschäftsführer)</p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h3 className="font-bold mb-2">{t.contractor.contact}</h3>
            <p>
              Alexander Weise<br />
              Tel.: +49 (89) 2154 4351<br />
              E-Mail: alexander.weise@nimbicon.de
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};